import React from "react";
import { Star } from "lucide-react";
import { useSubscription } from "../../lib/subscription";

/**
 * FoundingMemberBanner — subtle top-of-frame strip shown to hand-picked
 * founding members. Displays their badge number (e.g. "#000002") so they
 * know their status is recognized, and reinforces that all premium
 * features are unlocked. Non-dismissable by design — it's a mark of
 * status, not a nag.
 */
export const FoundingMemberBanner = () => {
  const { founding } = useSubscription();
  if (!founding) return null;

  return (
    <div
      data-testid="founding-member-banner"
      className="shrink-0 px-4 py-1.5 flex items-center gap-2"
      style={{
        background:
          "linear-gradient(90deg, rgba(57,255,20,0.10), rgba(0,229,255,0.10))",
        borderBottom: "1px solid rgba(57,255,20,0.25)",
      }}
    >
      <div
        className="w-5 h-5 rounded-full flex items-center justify-center shrink-0"
        style={{
          background: "linear-gradient(135deg,#39FF14,#00E5FF)",
        }}
      >
        <Star className="w-3 h-3 text-black" strokeWidth={2.5} fill="currentColor" />
      </div>
      <div className="min-w-0 flex-1 flex items-baseline gap-1.5">
        <span className="text-[10px] font-mono uppercase tracking-[0.16em] text-white font-semibold">
          Founding Member
        </span>
        <span
          className="text-[10px] font-mono tracking-wider"
          style={{ color: "#39FF14" }}
          data-testid="founding-member-badge"
        >
          {founding.badge}
        </span>
      </div>
      <span className="text-[9px] font-mono uppercase tracking-wider text-zinc-400">
        Lifetime · All features
      </span>
    </div>
  );
};
